import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import Suppliers from './pages/Suppliers';
import SupplierDetail from './pages/SupplierDetail';
import Tickets from './pages/Tickets';
import TicketForm from './pages/TicketForm';
import Payments from './pages/Payments';
import Destinations from './pages/Destinations';
import Airlines from './pages/Airlines';
import BankAccounts from './pages/BankAccounts';
import Expenses from './pages/Expenses';
import Users from './pages/Users';
import Reports from './pages/Reports';
import ClientDebts from './pages/ClientDebts';
import SupplierDebts from './pages/SupplierDebts';

// React Query client me caching agresiv
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minuta - të dhënat janë "fresh"
      cacheTime: 1000 * 60 * 30, // 30 minuta - ruaj në cache
      refetchOnWindowFocus: false, // Mos rifresko kur kthehesh në tab
      retry: 1,
    },
  },
});

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }
  
  return user ? children : <Navigate to="/login" />;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="clients" element={<Clients />} />
        <Route path="clients/:id" element={<ClientDetail />} />
        <Route path="suppliers" element={<Suppliers />} />
        <Route path="suppliers/:id" element={<SupplierDetail />} />
        <Route path="tickets" element={<Tickets />} />
        <Route path="tickets/new" element={<TicketForm />} />
        <Route path="tickets/:id/edit" element={<TicketForm />} />
        <Route path="payments" element={<Payments />} />
        <Route path="destinations" element={<Destinations />} />
        <Route path="airlines" element={<Airlines />} />
        <Route path="bank-accounts" element={<BankAccounts />} />
        <Route path="expenses" element={<Expenses />} />
        <Route path="users" element={<Users />} />
        <Route path="reports" element={<Reports />} />
        <Route path="client-debts" element={<ClientDebts />} />
        <Route path="supplier-debts" element={<SupplierDebts />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" />
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
